import { Component, OnInit, Input, ViewChild, OnChanges, ViewChildren, ChangeDetectorRef, QueryList } from '@angular/core';
import { MatTableDataSource, MatDialogConfig, MatDialog, MatPaginator, MatSort, MatTable } from '@angular/material';
import { ViewRequest } from '../shared/view-request.model';
import { ReportsService } from '../shared/reports.service';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { SaveDescriptionDialogComponent } from 'src/app/core/modal/save-description-dialog/save-description-dialog.component';
import { DeclineAssigment } from '../../assessments/shared/decline-assigment.model';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-view-requests',
  templateUrl: './view-requests.component.html',
  styleUrls: ['./view-requests.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ViewRequestsComponent implements OnInit, OnChanges {
  displayedColumns: string[] = ['estado', 'nomMateriaSolic', 'codMateriaRecon',
                   'nota',  'semestre', 'operaciones'];
  dataSource: MatTableDataSource<ViewRequest>;
  messageError: String = '';
  claseMessage: String = 'messaje-error';
  expandedElement: ViewRequest | null;

  @Input() requests: ViewRequest[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<String>>;

  constructor(private dialog: MatDialog,
              private reporstService: ReportsService,
              private cd: ChangeDetectorRef) {
                this.setTable();
  }

  ngOnInit() {
    this.setTable();
  }

  decline(row: ViewRequest) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: '¿Esta seguro que desea declinar la Solicitud?'};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.openDialogDecline(row);
        }
    });

  }

  private openDialogDecline (row: ViewRequest) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'DECLINAR SOLICITUD', filedName: 'Justificación' };
    dialogConfig.width = '40%';
    const dialogRef = this.dialog.open(SaveDescriptionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
          const decline = new DeclineAssigment();
          decline.solicitud = row.codigo;
          decline.consecutivo = row.consecutivo;
          decline.justificacion = value;
          this.reporstService.declineRequest(decline).subscribe(
            (result) => {
              if (result.data) {
                if (result.data === 'OK') {
                  const index = this.requests.indexOf(row);
                  if (index > -1) {
                    this.requests.splice(index, 1);
                    this.setTable();
                 }
                  this.claseMessage = 'messaje-success';
                  this.messageError = 'Se declino la solicitud #' + row.codigo;
                } else {
                  this.claseMessage = 'messaje-error';
                  this.messageError = result.data;
                }
              }
            }
          );
      }
    });
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  toggleRow(element: ViewRequest) {
    element.observaciones !== null ?
    (this.expandedElement = this.expandedElement === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<String>).sort = this.innerSort.toArray()[index]);
  }

  ngOnChanges() {
    this.setTable();
  }

}
